import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Alert, AlertIcon } from "solveiq.designsystem";
import SuccessAlert from "../../components/SuccessAlert/SuccessAlert";
import RESTGatewayAPI from "../../api/gatewayAPI";

declare const agentUiURL: string;

export function ExternalAuthRegister() {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [showExistAccountModal, setShowExistAccountModal] = useState(false);

  const handleExternalRegister = async () => {
    // From params
    const name = searchParams.get("name");
    const email = searchParams.get("email");

    // Verify if the user exists
    const getExistAccountUrl = `/api/Checkout/existingaccount/${email}`;
    const responseExistAccount = await RESTGatewayAPI.get(getExistAccountUrl);
    // Should contain a property named AllowPurchase
    const shouldAllowCreateAccount =
      responseExistAccount?.data?.data?.AllowPurchase;
    //In case false the account already exists
    if (!shouldAllowCreateAccount) {
      setShowExistAccountModal(true);
      return;
    }

    const registerUrl = "/api/Checkout/subscribe/postinstall";
    const registerBody = {
      productID: 5,
      paymentInfo: { Name: name, Email: email },
      seatCount: 20,
      queryStringData: new URLSearchParams(window.location.search).toString(),
      uuid: searchParams.get("uuid"),
      isBeta: true,
      sendCheckLicense: true,
      showUI: true,
    };
    await RESTGatewayAPI.post(registerUrl, registerBody);
    // * Remove redirection, after gateway registration. Agent will deal with this.
    // if (res?.status === 200 && res?.data?.succeeded) {
    //   const redirectUrl = `${res?.data?.data?.RedirectUrl}`;
    //   window.open(redirectUrl, "_self", "noopener,noreferrer");
    // }
  };

  useEffect(() => {
    handleExternalRegister();
  }, []);

  return showExistAccountModal ? (
    <Alert
      isOpen={showExistAccountModal}
      icon={AlertIcon.Warning}
      approveHandler={() => {
        setShowExistAccountModal(false);
        if (agentUiURL)
          window.open(agentUiURL, "_blank", "noopener,noreferrer");
      }}
      closeHandler={() => {
        setShowExistAccountModal(false);
      }}
      title="Existing Account Detected"
      text="We've detected that you already have an account with Solve iQ Web."
      buttonText="Manage Account"
    />
  ) : (
    <SuccessAlert
      isOpen={true}
      title="Thanks for signing up!"
      text="Solve iQ Web should load momentarily."
    />
  );
}
